import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  mt_20: {
    marginTop: 20,
  },
  cssOutlinedInput: {
    "&$cssFocused $notchedOutline": {
      borderColor: `#2684FF !important`,
    },
  },
  textFieldStyle: {
    focused: {
      borderColor: "red",
    },
  },
}));

export default useStyles;



// WEBPACK FOOTER //
// ./src/styles.js